import { render } from "./StocksItem.vue?vue&type=template&id=2fa22adc&scoped=true"
import script from "./StocksItem.vue?vue&type=script&lang=js"
export * from "./StocksItem.vue?vue&type=script&lang=js"

import "./StocksItem.vue?vue&type=style&index=0&id=2fa22adc&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa22adc"]])

export default __exports__